import { IJobResponse, JobStatus } from '@kcftech/prometheus-client';
import { IssueUserInfo } from 'pages/Desk/issues/types';

export type RunningThresholdJob = Readonly<{
    id: string;
    fullName: string;
    enqueuedTime: Date;
    user: IssueUserInfo;
}>;

export type CompletedThresholdJob = Readonly<{
    id: string;
    fullName: string;
    finishedTime: Date;
    status: JobStatus;
    user: IssueUserInfo;
}>;

function toJobUser(job: IJobResponse): IssueUserInfo {
    return {
        id: job.User.UserId,
        firstName: job.User.UserFirstName,
        lastName: job.User.UserLastName,
        email: job.User.UserEmail,
        role: job.User.UserApplicationRole,
    };
}

function toFullName(job: IJobResponse): string {
    const fullName = `${job.User.UserFirstName} ${job.User.UserLastName}`.trim();
    return fullName || 'Unknown user';
}

export function toRunningThresholdJobs(jobs: IJobResponse[]): RunningThresholdJob[] {
    return jobs
        .filter(
            (job: IJobResponse) =>
                job.Status === JobStatus.Running || job.Status === JobStatus.Queued,
        )
        .map((job: IJobResponse) => {
            return {
                id: job.Id,
                fullName: toFullName(job),
                enqueuedTime: new Date(job.EnqueuedTime),
                user: toJobUser(job),
            };
        });
}

export function toCompletedThresholdJob(
    job: IJobResponse | undefined,
): CompletedThresholdJob | undefined {
    if (!job) {
        return undefined;
    }

    const completedTime = job.FinishedTime ?? job.ErroredTime;

    if (!completedTime) {
        return undefined;
    }

    return {
        id: job.Id,
        fullName: toFullName(job),
        finishedTime: new Date(completedTime),
        status: job.Status,
        user: toJobUser(job),
    };
}
